'use client';
import { useTranslations } from 'use-intl';

import { routes } from '~constants/routes';
import type { TGridFilterItem } from '~entities/grid';
import { useGridFilters } from '~features/gridFilters/hooks/useGridFilters';
import { CreatedBy } from '~features/gridFilters/model/types';
import { useSession } from '~hooks/useSession';
import { gridApi } from '~services/api/grid';
import { ButtonStroked } from '~shared/ui/atoms/Buttons/ButtonStroked';

import { GridFiltersFormFields as fields } from '../../model/names';
import { FilterButton } from '../FilterButton';
import { ButtonsContainer } from './styles';

type Props = {
	desires?: TGridFilterItem[];
};

export const DesireButtons = ({ desires = [] }: Props) => {
	const t = useTranslations('GridFilters');
	const { isDemoUser, isSuccess, isLoading: isSessionLoading } = useSession();

	const {
		filters,
		count,
		updateFilters,
		clearFilters,
		slug,
		resetManualUpdate,
	} = useGridFilters();

	const { data, isLoading: isFiltersLoading } = gridApi.useGetGridFiltersQuery(
		undefined,
		{
			skip: !!desires?.length,
		}
	);
	const items = data || desires;

	const isLoading =
		items.length === 0 && (isFiltersLoading || isSessionLoading);

	return (
		<ButtonsContainer>
			<FilterButton
				skeleton={isLoading}
				text={t('filtersAllButtonTitle')}
				selected={!slug && count === 0}
				onClick={clearFilters}
			/>
			{isSuccess && !isDemoUser && (
				// TODO: локализовать по аналогии с CreatedBySelector
				<>
					<FilterButton
						text="Community-made"
						selected={filters[fields.createdBy] === CreatedBy.community}
						onClick={() => {
							updateFilters({
								[fields.createdBy]: CreatedBy.community,
							});
						}}
					/>
					<FilterButton
						text="Celebrity"
						selected={filters[fields.createdBy] === CreatedBy.celebrity}
						onClick={() => {
							updateFilters({
								[fields.createdBy]: CreatedBy.celebrity,
							});
						}}
					/>
				</>
			)}
			{isFiltersLoading &&
				Array.from({ length: 8 }).map((_, index) => (
					<ButtonStroked
						skeleton={true}
						width={80}
						key={index.toString()}
						size="M"
					/>
				))}
			{items.map((desire) => {
				const active = !!slug && desire.category === slug;
				return (
					<FilterButton
						key={desire.id}
						href={desire.category && routes.explore.slug(desire.category)}
						text={desire.filter}
						selected={active}
						onClick={resetManualUpdate}
					/>
				);
			})}
		</ButtonsContainer>
	);
};
